import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { Permissions } from '../../permissions.enum';  
import { TranslationService } from '../../services/translation.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
  imports: [RouterModule, CommonModule],
})
export class SidebarComponent {

  Permissions = Permissions;  
  username = "";

  constructor(public authService: AuthService, public translationService: TranslationService) {}

  ngOnInit() {
    const keys = Object.keys(sessionStorage);
    keys.forEach((key) => {
      const value = sessionStorage.getItem(key);
      if (value !== null) {
        try {
          const parsedValue = JSON.parse(value);
            if (parsedValue && parsedValue.authorityType === "MSSTS") {
              this.username = parsedValue.name
          }
          } catch (e) {
          }
      }
    });
  }

  toggleSidebar() {
    document.getElementById('sidebar')?.classList.toggle('active');
    document.getElementById('page-content-wrapper')?.classList.toggle('active');
  }

  hasPermission(permission: Permissions): boolean {
    return this.authService.hasPermission(permission);
  }
}
